<div class="section-center" role="alert" aria-busy="true" aria-live="polite">
  @if (!isIEVersion9OrBelow) {
    <div class="loading">
      @if (!isIE) {
        <svg
          id="loadingCircle"
          class="circular"
          viewBox="25 25 50 50"
          >
          <circle
            class="path-2"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="3"
            stroke-miterlimit="10"
            />
            <circle
              class="path"
              cx="50"
              cy="50"
              r="20"
              fill="none"
              stroke-width="3"
              stroke-miterlimit="10"
              />
            </svg>
          }
          @if (isIE) {
            <svg id="loadingCircle" class="circular" viewBox="25 25 50 50">
              <circle
                class="path-2"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#EC0000"
                stroke-width="3"
                stroke-miterlimit="10"
                />
                <circle
                  class="path-ie"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  stroke="#EC0000"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  />
                </svg>
              }
              <h2 class="row-details f-title">Please Wait</h2>
              <h3 class="row-details firefly">Don't leave or refresh this page</h3>
            </div>
          }

          @if (isIEVersion9OrBelow) {
            <div class="loading">
              <img src="assets/img/preloader.gif" alt="loading" class="iePreloader" />
              <h2 class="row-details f-title">Please Wait</h2>
              <h3 class="row-details firefly">Don't leave or refresh this page</h3>
            </div>
          }
        </div>
